import { Routes as RRRoutes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

// Admin Pages
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import CreateSession from '../pages/CreateSession';
import SessionDetail from '../pages/SessionDetail';
import Settings from '../pages/Settings';

// Customer Pages
import ProofViewer from '../pages/ProofViewer';
import ProofSummary from '../pages/ProofSummary';

// Public Pages
import LandingPage from '../pages/LandingPage';

/**
 * Application Routes
 *
 * Public routes:
 * - / - Landing page (customer-friendly)
 * - /proof/:sessionId - Proof review
 * - /proof/:sessionId/summary - Review summary
 *
 * Admin routes (protected):
 * - /admin/login - Login page
 * - /admin/dashboard - Session list
 * - /admin/sessions/new - Create session
 * - /admin/sessions/:id - Session details
 */
const Routes = () => {
  return (
    <RRRoutes>
      {/* Public landing page */}
      <Route path="/" element={<LandingPage />} />

      {/* Admin Login (public) */}
      <Route path="/admin/login" element={<Login />} />

      {/* Admin Dashboard (protected) */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Create Session (protected) */}
      <Route
        path="/admin/sessions/new"
        element={
          <ProtectedRoute>
            <CreateSession />
          </ProtectedRoute>
        }
      />

      {/* Session Detail (protected) */}
      <Route
        path="/admin/sessions/:id"
        element={
          <ProtectedRoute>
            <SessionDetail />
          </ProtectedRoute>
        }
      />

      {/* Settings (protected) */}
      <Route
        path="/admin/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />

      {/* Legacy admin redirect */}
      <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

      {/* Customer proof routes (public - access via UUID) */}
      <Route path="/proof/:sessionId" element={<ProofViewer />} />
      <Route path="/proof/:sessionId/summary" element={<ProofSummary />} />

      {/* 404 */}
      <Route
        path="*"
        element={
          <div className="not-found-page">
            <div className="not-found-content">
              <h1>404</h1>
              <p>Page not found</p>
              <a href="/" className="not-found-link">
                Back to Home
              </a>
            </div>
          </div>
        }
      />
    </RRRoutes>
  );
};

export default Routes;
